import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {Badge} from "react-bootstrap";


const TableTypeIconCount = (props) => {

    return(
        <span className="my-auto">
            <small><FontAwesomeIcon icon={props.icon} /> </small>
            <Badge pill bg="success">{props.children}</Badge>
        </span>
    )
}

export default TableTypeIconCount;